export default __webpack_public_path__ + "static/media/linkedin.a7509b75.png";